export default __webpack_public_path__ + "static/media/logo.13d2cfe3.png";